import { FormDateInput } from 'components/form-fields';
import { useValidation } from 'hooks/useValidation';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Fragment, useEffect } from 'react';
import classNames from 'classnames';

export function OcrDateLayout(
    {
        loading = false,
        disabled = false,
        readonly = false,
        layout,
        onChange
    }
) {
    const [_, errors, validate] = useValidation();

    useEffect(() => {
        validateLayout();
    }, [layout.answer]);

    function validateLayout() {
        const required = layout.requiredAnswerCount > 0;
        const rules = [{ fieldName: 'answer', required: required }];
        validate(rules, layout);
    }

    function onValueChange(value) {
        const clonedLayout = { ...layout };

        clonedLayout.answer = value ? moment(value).format("YYYY-MM-DD") : null;

        onChange(clonedLayout);
    }

    return (
        <Fragment>
            <div className={classNames("form-field", { "hide-in-print": !readonly, "hidden": readonly })}>
                <FormDateInput
            loading={loading}
            onChange={onValueChange}
            value={layout.answer ? moment(layout.answer).toString() : null}
            headingText={layout.secondaryLayoutTitle}
            disabled={disabled}
            dangerHelperText={errors.answer}
                />
            </div>
            <p className={classNames({ "show-in-print": !readonly, "visible": readonly, "bp6-skeleton": loading })}>{moment(layout.answer).format('DD/MM/YYYY')}</p>
        </Fragment>
    );
}

OcrDateLayout.propTypes = {
    loading: PropTypes.bool,
    layout: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool
};
